import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userType',
})
export class UserTypePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    if (!value || typeof value !== 'string') {
      return value;
    }

    if (value === 'manager') {
      return 'Project Manager';
    }
    if (value === 'general_contractor') {
      return 'General Contractor';
    }
    if (value === 'material_supplier') {
      return 'Material Supplier';
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
